import { useEffect, useState } from 'react';
export const useIsSticky = (ref, stuckClass = 'cb-sticky-active', unstuckClass = null) => {
    const [isSticky, setIsStuck] = useState(false);
    const stickyClassName = isSticky ? stuckClass : unstuckClass;
    useEffect(() => {
        const cachedRef = ref.current;
        const observer = new window.IntersectionObserver(([e]) => {
            setIsStuck(e.intersectionRatio < 1);
        }, { threshold: [1] });
        observer.observe(cachedRef);
        return () => observer.unobserve(cachedRef);
    }, [ref]);
    return { isSticky, stickyClassName };
};
//# sourceMappingURL=useIsSticky.js.map